import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { usePost } from '../../../hooks/post/usePost'

import { Box, Sheet, CircularProgress } from '@mui/joy';

import TemplatePost from '../../../components/module/TemplatePost/TemplatePost';
import ServerError from '../../../components/module/ServerError/ServerError';

function PageShowPostEmbed() {
    const { idUser, idPost } = useParams();
    const { post, user, error, loading } = usePost(idUser, idPost);

    useEffect(() => {
        const root = document.getElementById('root');

        // CssBaseline (Joy) красит body в background.body (голубоватый #fbfcfe).
        // В embed фон вокруг карточки делаем прозрачным, чтобы был виден фон
        // страницы-хоста. Фон самой карточки поста (Sheet surface) сохраняется.
        const prevBody = document.body.style.background;
        const prevHtml = document.documentElement.style.background;
        document.body.style.background = 'transparent';
        document.documentElement.style.background = 'transparent';

        // main.css форсит #root { height: 100dvh !important } — из-за этого страница
        // не сжимается по контенту. В embed снимаем, чтобы высота равнялась посту.
        const prevRootHeight = root?.style.getPropertyValue('height') ?? '';
        const prevRootPriority = root?.style.getPropertyPriority('height') ?? '';
        root?.style.setProperty('height', 'auto', 'important');

        // Авто-ресайз iframe: сообщаем родителю актуальную высоту контента.
        // ResizeObserver ловит и догрузку картинок/шрифтов, и смену ширины.
        const sendHeight = () => {
            const height = Math.ceil(document.documentElement.scrollHeight);
            window.parent?.postMessage({ type: 'aquarium-embed-height', height }, '*');
        };

        sendHeight();
        const ro = new ResizeObserver(sendHeight);
        ro.observe(document.body);
        window.addEventListener('load', sendHeight);

        return () => {
            ro.disconnect();
            window.removeEventListener('load', sendHeight);
            document.body.style.background = prevBody;
            document.documentElement.style.background = prevHtml;
            root?.style.setProperty('height', prevRootHeight, prevRootPriority);
        };
    }, []);

    return (
        <Sheet
            variant="outlined"
            sx={{
                maxWidth: 600,
                mx: 'auto',
                px: 2,
                pt: 1,
                pb: 2,
                borderRadius: '24px',
                boxSizing: 'border-box',
            }}
        >
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <ServerError />
            ) : post && user ? (
                <TemplatePost post={post} user={user} menu={false} embed={true} />
            ) : null}
        </Sheet>
    );
}

export default PageShowPostEmbed
